import React from 'react';
import { walkClaimText } from '../../../../lib/walkClaimText';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { PowerIntentIntroStrip } from './PowerIntentIntroStrip';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const CurtailmentRiskSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const text = report.powerAnalysis?.curtailmentRisk;
  return (
    <SectionShell label={label} hasData={!!text}>
      <PowerIntentIntroStrip report={report} focus="curtailment" />
      {text && (
        <EditorialSubsection theme={theme} label="Curtailment exposure">
          {walkClaimText(text, report.references)}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
